import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ReportsRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);
  return userInfo && (userInfo.isAdmin || userInfo.isReporter) ? (
    <Outlet />
  ) : (
    <Navigate to='/login' replace />
  );
};
export default ReportsRoute;